export function EmptyState({ title, description }: { title: string; description: string }) {
  return (
    <div className="border border-dashed border-slate-300 rounded-lg p-6 bg-white/70 text-center">
      <strong className="text-sm text-slate-700">{title}</strong>
      <p className="text-xs text-slate-500 mt-1">{description}</p>
    </div>
  )
}
